/*
 * PMS Starter Kit stepper in the product grids' quick-buy drawer.
 *
 * The grids (sections/section-gigi-product-grid.liquid, homepage + LP, and
 * sections/gigi-collection-grid.liquid, every collection) open ONE shared
 * drawer per section and fill it from the clicked card's JSON. Their picker
 * is a single flavour row with one button per variant, which for the kit
 * (Flavour x Bottle x Travel Pack = 18 variants) printed 18 emoji pills.
 *
 * This file leaves those sections' scripts untouched. snippets/gigi-kit-drawer
 * puts the PDP's own "Build your kit" card (snippets/gigi-bundle-contents) in
 * a <template data-pg-kit> on kit cards only. When a kit card opens the
 * drawer, the section fills it as usual; then this controller:
 *   - marks the drawer .is-kit (CSS hides the flavour row and guarantee line),
 *   - drops a fresh copy of the kit card under the one-time row,
 *   - runs the same four-step flow as the PDP: no pick on open, a pick closes
 *     its step and opens the next, Edit reopens one, the gift bag is a
 *     No thanks / Add toggle,
 *   - keeps Add to cart and Checkout waiting until the tub, travel pack and
 *     bottle are chosen (a click on a waiting button opens the step still
 *     needed),
 *   - and adds the chosen kit variant, plus the bag as its own line, itself.
 * Opening any other card's drawer removes all of it again.
 *
 * The pure part (`core`) is unit-tested in tests/kit-drawer.mjs; the browser
 * flow in tests/kit-drawer-e2e.mjs.
 */
(function (root) {
  'use strict';

  var core = {
    // Index of the variant whose options equal `cur` with option `oi` set to
    // `val`; else the first variant carrying `val` at `oi`; else -1. Same rule
    // as gbPick() in the PDP buy box.
    resolve: function (variants, cur, oi, val) {
      var fallback = -1;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options || [];
        if (o[oi] !== val) continue;
        if (fallback < 0) fallback = i;
        var same = true;
        for (var k = 0; k < o.length; k++) { if (k !== oi && o[k] !== (cur || [])[k]) { same = false; break; } }
        if (same) return i;
      }
      return fallback;
    },
    // Option index a step kind stands for; -1 for the gift bag (optional).
    optionFor: function (kind, oi) {
      oi = oi || {};
      if (kind === 'flavour') return oi.flavour == null ? 0 : oi.flavour;
      if (kind === 'travel') return oi.travel == null ? -1 : oi.travel;
      if (kind === 'bottle') return oi.bottle == null ? 1 : oi.bottle;
      return -1;
    },
    // First required step kind (in step order) not chosen yet, or ''.
    nextNeeded: function (kinds, oi, touched) {
      for (var i = 0; i < kinds.length; i++) {
        var key = core.optionFor(kinds[i], oi);
        if (key < 0) continue;
        if (!touched[key]) return kinds[i];
      }
      return '';
    },
    // Text shown in a finished step's row.
    stepValue: function (kind, options, oi, addonOn) {
      options = options || [];
      if (kind === 'addon') return addonOn ? 'Added' : 'No bag';
      if (kind === 'travel' && core.optionFor('travel', oi) < 0) return options[core.optionFor('flavour', oi)] || '';
      var k = core.optionFor(kind, oi);
      return k < 0 ? '' : (options[k] || '');
    },
    // Cart payload: the kit variant, then the add-on as its own line.
    items: function (variantId, addonId, addonOn) {
      var items = [{ id: Number(variantId), quantity: 1 }];
      if (addonOn && addonId) items.push({ id: Number(addonId), quantity: 1 });
      return items;
    },
    // [now, was] price strings for the one-time row. sums = the card's
    // per-variant [worth, save, savingCents, priceWithAddon, compareWithAddon].
    prices: function (priceText, sums, addonOn) {
      if (!sums) return [priceText, ''];
      if (addonOn && sums[3]) return [sums[3], sums[4] || ''];
      return [priceText, sums[2] > 0 ? sums[0] : ''];
    }
  };

  if (typeof module !== 'undefined' && module.exports) { module.exports = core; return; }
  if (root.GigiKitDrawer) return;
  root.GigiKitDrawer = { core: core };

  var doc = root.document;
  var S = null; // the mounted kit: one drawer at a time

  function money(cents) {
    try {
      if (root.theme && root.theme.formatMoney && root.theme.moneyFormat) return root.theme.formatMoney(cents, root.theme.moneyFormat);
    } catch (e) {}
    return '€' + (cents / 100).toFixed(2);
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function modalFor(card) {
    var grid = card.closest('[id^="GigiPg--"]');
    return grid ? doc.getElementById('GigiPgm--' + grid.id.slice(8)) : null;
  }

  function variant() { return S.variants[S.vi]; }
  function kinds() { return Array.prototype.map.call(S.card.querySelectorAll('[data-gb-step]'), function (s) { return s.getAttribute('data-gb-value'); }); }
  function addonOn() { return !!(S.addonBox && S.addonBox.checked); }
  function sums() { return S.parts.sums ? S.parts.sums[String(variant().id)] : null; }
  function stepNeed(kind) {
    var step = S.card.querySelector('[data-gb-value="' + kind + '"]');
    return (step && step.getAttribute('data-gb-need')) || '';
  }

  function render() {
    var v = variant(), opts = v.options || [], oi = S.parts.oi;
    S.card.querySelectorAll('[data-gb-pick]').forEach(function (tile) {
      var pick = tile.getAttribute('data-gb-pick'), sep = pick.indexOf('|'), k = Number(pick.slice(0, sep));
      tile.setAttribute('aria-pressed', (S.touched[k] && pick.slice(sep + 1) === opts[k]) ? 'true' : 'false');
    });
    S.card.querySelectorAll('[data-gb-step]').forEach(function (step) {
      var n = Number(step.getAttribute('data-gb-step'));
      var open = S.open === n, done = !open && S.reached > n;
      step.classList.toggle('is-open', open);
      step.classList.toggle('is-done', done);
      var body = step.querySelector('.gigi-binc__body');
      if (body) body.setAttribute('aria-hidden', open ? 'false' : 'true');
      var btn = step.querySelector('[data-gb-open]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var val = step.querySelector('[data-gb-step-value]');
      if (val) val.textContent = done ? core.stepValue(step.getAttribute('data-gb-value'), opts, oi, addonOn()) : '';
    });
    var sm = sums(), sumEl = S.card.querySelector('[data-gb-sum]');
    if (sumEl && S.parts.sums) {
      if (sm && sm[2] > 0) {
        sumEl.hidden = false;
        var w = S.card.querySelector('[data-gb-worth]'), sv = S.card.querySelector('[data-gb-save]');
        if (w) w.textContent = sm[0];
        if (sv) sv.textContent = sm[1];
      } else { sumEl.hidden = true; }
    }
    renderPrice();
    renderWait();
  }

  function renderPrice() {
    var el = S.modal.querySelector('[data-pgm-once-price]');
    if (!el) return;
    var p = core.prices(money(variant().price), sums(), addonOn());
    el.innerHTML = (p[1] ? '<del>' + esc(p[1]) + '</del>' : '') + esc(p[0]);
  }

  function renderWait() {
    var need = core.nextNeeded(kinds(), S.parts.oi, S.touched);
    var avail = variant().available !== false;
    var waiting = !!need || !avail;
    S.wait.hidden = !waiting;
    S.wait.textContent = need ? 'Choose your ' + stepNeed(need) + ' to continue.' : (avail ? '' : 'This combination is sold out. Choose another.');
    S.modal.querySelectorAll('[data-pgm-add], [data-pgm-checkout]').forEach(function (b) {
      b.classList.toggle('is-waiting', waiting);
      if (waiting) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
  }

  function advance(step) {
    var n = Number(step.getAttribute('data-gb-step')), next = Number(step.getAttribute('data-gb-next'));
    S.reached = Math.max(S.reached, n + 1);
    S.open = next;
    if (next === 0) S.reached = 99;
  }

  function onCardClick(e) {
    if (!S) return;
    var t = e.target.closest ? e.target.closest('[data-gb-pick], [data-gb-open], [data-gb-bag]') : null;
    if (!t || !S.card.contains(t)) return;
    e.preventDefault();
    if (t.hasAttribute('data-gb-open')) { S.open = Number(t.getAttribute('data-gb-open')); render(); return; }
    if (t.hasAttribute('data-gb-bag')) {
      var want = t.getAttribute('data-gb-bag') === '1';
      if (S.addonBox) S.addonBox.checked = want;
      t.parentNode.querySelectorAll('[data-gb-bag]').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
      advance(t.closest('[data-gb-step]'));
      render();
      return;
    }
    var pick = t.getAttribute('data-gb-pick'), sep = pick.indexOf('|'), k = Number(pick.slice(0, sep));
    var target = core.resolve(S.variants, variant().options, k, pick.slice(sep + 1));
    S.touched[k] = true;
    if (target > -1) S.vi = target;
    var step = t.closest('[data-gb-step]');
    if (step) advance(step);
    render();
  }

  function openNeeded() {
    var need = core.nextNeeded(kinds(), S.parts.oi, S.touched);
    var step = need && S.card.querySelector('[data-gb-value="' + need + '"]');
    if (!step) return;
    S.open = Number(step.getAttribute('data-gb-step'));
    render();
    if (step.scrollIntoView) step.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function openCartDrawer() {
    var cartEl = doc.querySelector('cart-element');
    if (cartEl && typeof cartEl.openCartDrawer === 'function') { cartEl.openCartDrawer(); return; }
    doc.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
  }

  function add(goToCheckout, btn) {
    var s = S;
    var addUrl = (root.theme && root.theme.routes && root.theme.routes.cart_add_url) ? root.theme.routes.cart_add_url : '/cart/add';
    if (addUrl.indexOf('.js') === -1) addUrl += '.js';
    btn.disabled = true;
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: core.items(variant().id, s.parts.addon && s.parts.addon.id, addonOn()) })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      if (!res.ok || (res.body && res.body.status && res.body.status !== 200)) {
        s.wait.hidden = false;
        s.wait.textContent = (res.body && (res.body.description || res.body.message)) || 'Something went wrong. Please try again.';
        return;
      }
      if (goToCheckout) { root.location.href = '/checkout'; return; }
      var close = s.modal.querySelector('.gigi-pgm__close[data-pgm-close]');
      if (close) close.click();
      openCartDrawer();
      doc.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      doc.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
      root.requestAnimationFrame(function () { root.requestAnimationFrame(openCartDrawer); });
    })
    .catch(function () {
      s.wait.hidden = false;
      s.wait.textContent = 'Something went wrong. Please try again.';
    })
    .finally(function () { btn.disabled = false; });
  }

  function unmount(modal) {
    if (!modal) return;
    var old = modal.querySelector('[data-kd]');
    if (old) old.parentNode.removeChild(old);
    var w = modal.querySelector('[data-kd-wait]');
    if (w) w.parentNode.removeChild(w);
    var foot = modal.querySelector('.gigi-pgm__foot');
    if (foot) foot.classList.remove('has-kd-wait');
    modal.querySelectorAll('[data-pgm-add], [data-pgm-checkout]').forEach(function (b) { b.classList.remove('is-waiting'); b.removeAttribute('aria-disabled'); });
    modal.classList.remove('is-kit');
    if (S && S.modal === modal) S = null;
  }

  function mount(card, modal) {
    unmount(modal);
    var tpl = card.querySelector('template[data-pg-kit]');
    var vj = card.querySelector('[data-pg-kit-variants]');
    if (!tpl || !vj) return;
    var variants;
    try { variants = JSON.parse(vj.textContent); } catch (e) { return; }
    var wrap = doc.createElement('div');
    wrap.className = 'gigi-kd';
    wrap.setAttribute('data-kd', '');
    wrap.appendChild(tpl.content.cloneNode(true));
    var kitCard = wrap.querySelector('[data-gb-card]');
    if (!kitCard) return;
    var parts = {};
    try { parts = JSON.parse(kitCard.querySelector('[data-gb-parts]').textContent); } catch (e) { parts = {}; }
    if (!parts.oi) parts.oi = { flavour: 0, travel: -1, bottle: 1 };
    var once = modal.querySelector('[data-pgm-type="onetime"]');
    if (!once) return;
    once.parentNode.insertBefore(wrap, once.nextSibling);
    var foot = modal.querySelector('.gigi-pgm__foot');
    var wait = doc.createElement('p');
    wait.className = 'gigi-kd__wait';
    wait.setAttribute('data-kd-wait', '');
    wait.setAttribute('aria-live', 'polite');
    if (foot) { foot.insertBefore(wait, foot.firstChild); foot.classList.add('has-kd-wait'); }
    var vi = 0;
    for (var i = 0; i < variants.length; i++) { if (variants[i].available) { vi = i; break; } }
    S = { modal: modal, card: kitCard, variants: variants, parts: parts, vi: vi, touched: {}, open: 1, reached: 1, addonBox: kitCard.querySelector('[data-gb-addon]'), wait: wait };
    if (S.addonBox) S.addonBox.checked = false;
    kitCard.addEventListener('click', onCardClick);
    modal.classList.add('is-kit');
    render();
  }

  // After the section's own handler has opened and filled the drawer (it
  // listens on the button itself, so it always runs first), swap in the kit.
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pg-open]') : null;
    if (!btn) return;
    var card = btn.closest('[data-pg-card]');
    if (!card) return;
    var modal = modalFor(card);
    if (!modal || !modal.classList.contains('is-open')) return;
    if (card.querySelector('template[data-pg-kit]')) mount(card, modal); else unmount(modal);
  });

  // The drawer's own buttons: while a kit is mounted they are ours. Capture
  // phase on the document runs before the section's listeners on the buttons.
  doc.addEventListener('click', function (e) {
    if (!S) return;
    var btn = e.target.closest ? e.target.closest('[data-pgm-add], [data-pgm-checkout]') : null;
    if (!btn || !S.modal.contains(btn)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.classList.contains('is-waiting')) { openNeeded(); return; }
    add(btn.hasAttribute('data-pgm-checkout'), btn);
  }, true);

  // The section re-writes the one-time price when its row is clicked.
  doc.addEventListener('click', function (e) {
    if (!S || !S.modal.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[data-pgm-type]')) renderPrice();
  });
})(typeof window !== 'undefined' ? window : this);
